import { CompanyState } from "../../type/company-state";

export const clearSelectedCompanyWithCollaborativesDispatch = (
  state: CompanyState
) => {
  state.selectedCompanyWithCollaboratives = undefined;
};
